import React from 'react';
import { useImportList } from './useImportList';
import { ExpandedRow } from './ExpandedRow';
import { DataTable } from '../../../Components/DataTable';
import { Typography } from '~/UIKit';
import { useTranslation } from 'react-i18next';
import { importPageStyles } from '../Import.styles';

export const ImportList = () => {
  const { importList, tableDefinition } = useImportList();
  const { t } = useTranslation();
  const { classes } = importPageStyles();

  if (!importList?.length) return null;

  return (
    <>
      <Typography className={`${classes.subHeader} ${classes.importHistory}`} variant="h5">
        {t('app.importHistory')}
      </Typography>
      <DataTable
        data={importList || []}
        tableDefinition={tableDefinition}
        getExpandedRow={(rowImport) => <ExpandedRow importRow={rowImport} />}
        rowsAreExpandable
      />
    </>
  );
};
